import { Flex } from '@chakra-ui/react';
import { ComponentProps } from 'react';
import { DismissableInfo } from '~/common/components/DismissableInfo/DismissableInfo';
import { BuyerFormFields } from '../../BuyerFormFields';
import { FormCard } from './FormCard';

export const BuyerFormCard = (
  props: ComponentProps<typeof BuyerFormFields>
) => {
  return (
    <FormCard label="Basics">
      <Flex direction="column" gap={2}>
        <BuyerFormFields {...props} />
        <DismissableInfo mt={4}>
          We will never contact your client without your permission
        </DismissableInfo>
      </Flex>
    </FormCard>
  );
};
